export default __webpack_public_path__ + "static/media/flop-equity-rangevsrange_0041_thumb.2f5f1b18.jpg";